import styled, {keyframes}from "styled-components"
// Estilo de texto del tema (theme.textStyles): small, medium, large o xlarge.
const textStyle = ({ theme, textStyle }) => theme.textStyles && theme.textStyles[textStyle]

// textStyle es una prop pública de Text (no $textStyle); se evita que llegue al <span>.
const notTextStyle = (prop) => prop !== 'textStyle'

export const textScaleOnce = keyframes`
  0% {
    -webkit-transform: scale(0.2);
    transform: scale(0.2);
  }
  10% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
`
const textScaleRepeat = keyframes`
  0% {
    -webkit-transform: scale(0.9);
    transform: scale(0.9);
  }
  100% {
    -webkit-transform: scale(1.2);
    transform: scale(1.2);
  }
`

export const fadeInBottom = keyframes`
  0% {
    -webkit-transform: translateY(50px);
            transform: translateY(50px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
    opacity: 1;
  }
`

export const pulsateBck = keyframes`
  0% {
    -webkit-transform: scale(1.1);
            transform: scale(1.1);
  }
  50% {
    -webkit-transform: scale(0.9);
            transform: scale(0.9);
  }
  100% {
    -webkit-transform: scale(1.1);
            transform: scale(1.1);
  }
`

export const TextGold = styled.span.withConfig({ shouldForwardProp: notTextStyle }).attrs((props) => ({ textStyle: props.textStyle === undefined ? 'medium' : props.textStyle }))`
  ${textStyle}
  animation: ${textScaleOnce} 10s cubic-bezier(0.680, -0.550, 0.265, 1.550) alternate both infinite;
  color: #D5AD6D; 
  background-image: -webkit-linear-gradient(transparent, transparent),
  -webkit-linear-gradient(left, #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  text-transform: uppercase;
  text-align: center;
  font-weight: 900;
`

export const TextGoldRepeat = styled.span.withConfig({ shouldForwardProp: notTextStyle }).attrs((props) => ({ textStyle: props.textStyle === undefined ? 'medium' : props.textStyle }))`
  ${textStyle}
  animation: ${textScaleRepeat} 1s cubic-bezier(0.550, 0.085, 0.680, 0.530) infinite alternate 1s both;
  color: #D5AD6D;
  background: -webkit-linear-gradient(transparent, transparent),
  -webkit-linear-gradient(left, rgba(213, 173, 109, 1) 0%, rgba(213, 173, 109, 1) 26%, rgba(226, 186, 120, 1) 35%, rgba(163, 126, 67, 1) 45%, rgba(145, 112, 59, 1) 61%, rgba(213, 173, 109, 1) 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  text-transform:uppercase;
  text-align:center;
  font-weight:900;
`

// textStyle por defecto en attrs: React 19 ya no aplica defaultProps a componentes de función.
const Text = styled.span.withConfig({ shouldForwardProp: notTextStyle }).attrs((props) => ({ textStyle: props.textStyle === undefined ? 'medium' : props.textStyle }))`
  text-transform: uppercase;
  color:white;
  text-align:center;
  ${textStyle}
`


export default Text